import React, { useState, useEffect } from 'react';
import "./tableStyle.css"
import { getUserList } from '../../Services/Services';
import { Col, Input, Button,Form } from 'antd';
import AddNewStaff from './AddNewStaff';
import UpdateStaff from './UpdateStaff';
import Header from '../Header-Footer/Header';
import * as XLSX from 'xlsx'; // Import xlsx library
import Footer from '../Header-Footer/Footer';
import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { FaFilePdf, FaFileExcel } from 'react-icons/fa';
export default function Staff() {
  const [userList, setuserList] = useState([]);
  const [userDetails, setuserDetails] = useState([])
  const [form] = Form.useForm();
  useEffect(() => {
    GetUserList();
  }, []);

  const GetUserList = async () => {
    const response = await getUserList();
    const filterData = response.filter(o => o.user_type === 'Staff' && o.com_name === localStorage.getItem('com_name'))
    if (filterData) {
      const sortedArray = [...filterData].sort((a, b) => b.id - a.id);
      setuserList(sortedArray);
      setuserDetails(sortedArray)
    }
  }

  const handleValuesChange = (changedValues, allValues) => {
    const filteredData = userDetails.filter(item => 
        item.name.toLowerCase().includes((allValues.name || '').toLowerCase()) &&
        item.contact_no.toLowerCase().includes((allValues.contact_no || '').toLowerCase())
    );

    setuserList(filteredData);
};
  const handleExportToExcel = () => {
    const workbook = XLSX.utils.book_new();
    const wsData = userList.map((e, index) => [
      index + 1,
      e.name,
      e.email,
      e.contact_no,
      e.gst_no,
      e.Address,
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([
      ['Sr. No', 'Staff Name', 'Email', 'Contact No.'],
      ...wsData,
    ]);

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Staff List');

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, 'Staff List.xlsx');
  };
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const [staffData, setstaffData] = useState()
  const findStaff = (id) => {
    setstaffData(userList.find(o => o.id === id))
  }
  return (
    <div style={{ height:'90vh' }}>
      <Header heading="STAFF VIEW" />
      <Form
        form={form}
        layout="vertical"
        onValuesChange={handleValuesChange}
      >
      <div className=" grid grid-cols-1 sm:grid sm:grid-cols-3 sm:gap-2 m-auto px-5 sm:w-[70%]  md:w-[100%]" style={{ marginBottom: '10px' }}>
        <Col>
          <label><b>Search Staff Name</b></label><br />
          <Form.Item
            name='name'
          >
            <Input
              placeholder='Search by Staff Name'
            />
          </Form.Item>
        </Col>
        <Col>
          <label><b>Contact Number</b></label><br />
          <Form.Item
            name='contact_no'
          >
            <Input
              placeholder='Search by Contact Number'
            />
          </Form.Item>
        </Col>
        <Col>
          <AddNewStaff setuserList={setuserList} setuserDetails={setuserDetails} />
          <Button
            style={{
               top:'13px',
              margin: "10px",
              backgroundColor: 'black',
              color: 'white',
              fontWeight: '600'
            }}
            onClick={handlePrint}
          >
            <FaFilePdf/>
          </Button>
          <Button
            style={{
               top:'13px',
              margin: "10px",
              backgroundColor: 'green',
              color: 'white',
              fontWeight: '600'
            }}
            onClick={handleExportToExcel}
          >
           <FaFileExcel/>
          </Button>
        </Col>
      </div>
      </Form>
      <div className="table-wrapper" ref={componentRef}>
        <table id="my-table" className="w-full">
      {/* <table id="my-table" className="w-full relative" ref={componentRef}>
        <thead className="bg-[#151B54] w-full text-white"> */}
          <tr>
            <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">Sr. No</th>
            <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Id</th>

            <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Staff Name</th>
            <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">Email</th>
            <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Contact No</th>
            <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Action</th>


          </tr>
        {/* </thead> */}
        <tbody>
          {userList.map((e, index) => (
            <tr key={e.client_id}>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{index + 1}</td>

              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.id}</td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.name}</td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.email}</td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.contact_no}</td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">

                <button onClick={() => findStaff(e.id)}>
                  <UpdateStaff setuserList={setuserList} setuserDetails={setuserDetails} staffData={staffData} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {/* <Footer /> */}
      </div>
    </div>
  )
}
